import { Group } from "../types/user-groups/Group";
import { GroupsToImport } from "../types/user-groups/GroupsToImport";
import { TinyUserGroup } from "../types/user/UserGroupRelation";
import { axiosWithAuth } from "../utils/customAxios";
import { MsTeamsGroupImportResult } from "../types/user-groups/MsTeamsGroupImportResult";
import { ImportGroupsData } from "../types/user-groups/ImportGroupsData";
import { ApiResponse } from "../types/ApiResponse";

const userGroupsService = {
  getUserGroups: async (): Promise<Group[]> => {
    try {
      const response = await axiosWithAuth.get(`/group`);
      const groups: Group[] = response.data;
      return groups;
    } catch (ex) {
      throw ex;
    }
  },

  getRecordingNetworkGroups: async (userId: number): Promise<Group[]> => {
    try {
      const response = await axiosWithAuth.get(`/group/recordingnetwork/${userId}`);
      const groups: Group[] = response.data;
      return groups;
    } catch (ex) {
      throw ex;
    }
  },

  getTinyUserGroups: async (): Promise<TinyUserGroup[]> => {
    try {
      const response = await axiosWithAuth.get(`/group?features=minimum`);
      const groups: TinyUserGroup[] = response.data;
      return groups;
    } catch (ex) {
      throw ex;
    }
  },

  getUserGroupById: async (id: number): Promise<Group> => {
    try {
      const response = await axiosWithAuth.get(`/group/${id}`);
      const group: Group = response.data;
      return group;
    } catch (ex) {
      throw ex;
    }
  },

  fetchAllGroupsPaginated: async (skip: number = 0, take: number = 20, searchValue: string = ''): Promise<ApiResponse<Group>> => {
    try {
      const route = `/group/all?skip=${skip}&take=${take}&name=${searchValue}`;
      const response = await axiosWithAuth.get(route);
      const groups: ApiResponse<Group> = response.data;
      return groups;
    } catch (err) {
      throw err;
    }
  },

  upsertUserGroup: async (group: Group): Promise<Group> => {
    try {
      if (group.id > 0) {
        const response = await axiosWithAuth.put(`/group`, group);
        const upsertedGroup: Group = response.data;
        return upsertedGroup;
      } else {
        const response = await axiosWithAuth.post(`/group`, group);
        const upsertedGroup: Group = response.data;
        return upsertedGroup;
      }
    } catch (ex) {
      throw ex;
    }
  },

  deleteUserGroups: async (id: number): Promise<Group[]> => {
    try {
      const response = await axiosWithAuth.delete(`/group/${id}`);
      return response.data;
    } catch (ex) {
      throw ex;
    }
  },


  getGroupsToImport: async (customerId: number, platform: string, searchValue: string = "", NextPageUrl: string = ""): Promise<MsTeamsGroupImportResult> => {
    try {
      var apiUrl = `/group/import/${customerId}/${platform}`;
      var delimiter = "?";

      if (searchValue !== "") {
        apiUrl = apiUrl + delimiter + `searchValue=${searchValue}`;
        delimiter = "&";
      }

      if (NextPageUrl !== "") {
        apiUrl = apiUrl + delimiter + `nextPageUrl=${encodeURIComponent(NextPageUrl)}`;
      }

      const response = await axiosWithAuth.get(apiUrl);
      return response.data;
    } catch (ex) {
      throw ex;
    }
  },

  upsertImportedGroups: async (customerId: number, platform: string, importGroupsData: ImportGroupsData, allSelected: boolean): Promise<boolean> => {
    try {
      const response = await axiosWithAuth.post(`/group/import/${customerId}/${platform}`, importGroupsData);
      const success: boolean = response.data;
      return success;
    } catch (ex) {
      throw ex;
    }
  },
};

export default userGroupsService;
